import { MenuButton } from "shared/react";
import { type EarnedData, REWARD_TYPES, type RewardData } from "shared/schema";
import { getMediaImageStyle } from "shared/util/style";
import { EntityButton } from "../entity/EntityButton.js";
import { useEarnedItem } from "../util/data.js";
import { useItem } from "../util/db.js";
import { RewardInteractiveIcon } from "./RewardInteractiveIcon.js";
import { RewardMenu } from "./RewardMenu.js";

export function RawRewardCard({ id, reward, earned }: { id?: string; reward: RewardData; earned?: EarnedData | undefined }): React.ReactElement {
	const { name, creator, hue, type, image } = reward;
	const path = id ? `/reward/${id}` : undefined;
	return (
		<article className="card targeted pad-none" style={getMediaImageStyle(image, hue)}>
			<div className="panel pad-2x">
				<div className="space-xsmall">
					<RewardInteractiveIcon reward={reward} earned={earned} />
				</div>
				<h2 className="space-none">
					<a href={path} className="target">
						{name}
					</a>
				</h2>
				<p className="label space-none">{REWARD_TYPES[type]}</p>
			</div>
			{id ? <MenuButton menu={<RewardMenu id={id} />} mods="button-quiet pin-top pin-right" /> : null}
			<EntityButton entity={creator} mods="pin-bottom pin-left size-small" />
		</article>
	);
}

export function RewardCard({ id }: { id: string }): React.ReactElement {
	const rewardItem = useItem("reward", id);
	const earnedItem = useEarnedItem(id);
	return <RawRewardCard id={id} reward={rewardItem.data} earned={earnedItem.value} />;
}
